import Vue from "vue"
import VueRouter from "vue-router"
import VueCookie from "vue-cookie"
import bootstrap from "./bootstrap"
import routes from "./routes"
import store from "./store"

Vue.use(VueRouter)
Vue.use(VueCookie)
bootstrap(Vue)

// eslint-disable-next-line import/first
import "./assets/sass/app.scss" // Import your global SASS file
// eslint-disable-next-line import/first
import App from "./components/App.vue"

// Setup vue-router
const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        return { x: 0, y: 0 }
    }
})

window.nibnut_app = new Vue({
    el: "#app",
    store,
    router,
    render: h => h(App)
})
